import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Image icon for representing image files
 */
export const ImageIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
      <circle cx="8.5" cy="8.5" r="1.5"></circle>
      <polyline points="21 15 16 10 5 21"></polyline>
    </Icon>
  );
};

export default ImageIcon;
